import { SxProps, Theme } from "@mui/material"

// Unfortunately, TS loses the typing of SxProps hashes when merging 2 hashes.
// Use this function to keep the typing.
export default function mergeSx(
  ...sxs: (SxProps<Theme> | undefined)[]
): SxProps<Theme> {
  return Object.assign({}, ...sxs) as SxProps<Theme>
}
